/**
 * @file      /src/schedmsg/schedmsg-web.js
 * @author    Ryan Rossiter, ryan@kingsds.network
 * @date      March 2020
 *
 * This is the SchedMsg implementation for commands that are browser-specific
 * or have browser-specific behaviour.
 */

const { SchedMsg } = require('./schedmsg');

class SchedMsgWeb extends SchedMsg {
  constructor(worker) {
    super(worker);

    this.registerHandler('announce', this.onAnnouncement.bind(this));
    this.registerHandler('openPopup', this.onOpenPopup.bind(this));
    this.registerHandler('reload', this.onReload.bind(this));
  }

  onAnnouncement({ message }) {
    
    window.alert('DCP Worker Announcement: ' + message);

  }

  onOpenPopup({ href }) {
    window.open(href);
  }

  onReload() {
    const hash = window.location.hash;

    let newUrl = window.location.href.replace(/#.*/, '');
    newUrl += (newUrl.indexOf('?') === -1 ? '?' : '&');
    newUrl += 'dcp=a9e7f7e03401b8d2862f565386a9389324636c8e,' + Date.now() + hash;

    window.location.replace(newUrl);
  }
}

Object.assign(module.exports, {
  SchedMsgWeb
});
